import { render } from "./AvailableModels.vue?vue&type=template&id=08f0dacf"
import script from "./AvailableModels.vue?vue&type=script&lang=js"
export * from "./AvailableModels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__